import React from 'react';

export const ListItem = ({ isActive, label, handleSelect }) => (
    <div className={'list-label-list-item ' + (isActive && 'list-label-list-item--active')} onClick={() => handleSelect(label.name)}>
        {isActive && <i className="fa fa-check" />}
        {label.name}
    </div>
);
